module.exports = __webpack_public_path__ + "img/demo-speaking.2ca79e09.png";